export interface BankAccount {
  id: number;
  account_number: string;
  routing_number: string;
  account_nickname: string;
  account_subtype: "checking" | "savings";
  default: boolean;
  name: string;
  last4?: string;
}

export enum TransactionType {
  Invoice = "invoice",
  Payout = "payout"
}
